import React, { useState, useEffect } from 'react';
import { Card, Row, Col, Statistic, List, Tag, Button } from 'antd';
import { 
  ClockCircleOutlined, 
  CalendarOutlined, 
  BellOutlined,
  KeyOutlined,
  CheckCircleOutlined,
  CloseCircleOutlined,
  RightOutlined
} from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import api from '../utils/api';

const UserDashboard = () => {
  const [stats, setStats] = useState({
    accessRequests: [],
    notifications: [],
    schedule: null
  });
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    fetchDashboardData();
  }, []);

  const fetchDashboardData = async () => {
    try {
      setLoading(true);
      const [accessRequests, notifications] = await Promise.all([
        api.get('/api/access-requests'),
        api.get('/api/notifications')
      ]);

      setStats({
        accessRequests: accessRequests.data.slice(0, 5),
        notifications: notifications.data.slice(0, 5),
      });
    } catch (error) {
      console.error('Error fetching dashboard data:', error);
    } finally {
      setLoading(false);
    }
  };

  const getStatusColor = (status) => {
    const colors = {
      pending: 'gold',
      approved: 'green',
      rejected: 'red'
    };
    return colors[status] || 'default';
  };

  return (
    <div>
      <h2 style={{ marginBottom: 24 }}>Welcome Back!</h2>

      <Row gutter={[16, 16]}>
        {/* Quick Actions */}
        <Col xs={24} lg={8}>
          <Card title="Quick Actions" loading={loading}>
            <List
              itemLayout="horizontal"
              dataSource={[
                {
                  title: 'Request Access',
                  icon: <KeyOutlined />,
                  path: '/access'
                },
                {
                  title: 'View Schedule',
                  icon: <CalendarOutlined />,
                  path: '/schedule'
                },
                {
                  title: 'Check Notifications',
                  icon: <BellOutlined />,
                  path: '/notifications'
                }
              ]}
              renderItem={item => (
                <List.Item>
                  <Button 
                    type="text" 
                    icon={item.icon}
                    onClick={() => navigate(item.path)}
                    style={{ width: '100%', textAlign: 'left' }}
                  >
                    {item.title}
                    <RightOutlined style={{ float: 'right', marginTop: 4 }} />
                  </Button>
                </List.Item>
              )}
            />
          </Card>
        </Col>

        {/* Recent Access Requests */}
        <Col xs={24} lg={8}>
          <Card 
            title="Recent Access Requests" 
            loading={loading}
            extra={<Button type="link" onClick={() => navigate('/access')}>View All</Button>}
          >
            <List
              itemLayout="horizontal"
              dataSource={stats.accessRequests}
              locale={{ emptyText: 'No recent access requests' }}
              renderItem={request => (
                <List.Item>
                  <List.Item.Meta
                    title={request.department}
                    description={
                      <>
                        <Tag color={getStatusColor(request.status)}>
                          {request.status.toUpperCase()}
                        </Tag>
                        <span style={{ marginLeft: 8, color: '#666' }}>
                          {new Date(request.created_at).toLocaleDateString()}
                        </span>
                      </>
                    }
                  />
                </List.Item>
              )}
            />
          </Card>
        </Col>

        {/* Recent Notifications */}
        <Col xs={24} lg={8}>
          <Card 
            title="Recent Notifications" 
            loading={loading}
            extra={<Button type="link" onClick={() => navigate('/notifications')}>View All</Button>}
          >
            <List
              itemLayout="horizontal"
              dataSource={stats.notifications}
              locale={{ emptyText: 'No new notifications' }}
              renderItem={notification => (
                <List.Item>
                  <List.Item.Meta
                    title={notification.title}
                    description={
                      <span style={{ color: '#666' }}>
                        {new Date(notification.created_at).toLocaleDateString()}
                      </span>
                    }
                  />
                </List.Item>
              )}
            />
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default UserDashboard;
